var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul-select',{attrs:{"placeholder":"请选择"},on:{"change":_vm.change},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}},_vm._l((_vm.languages),function(item){return _c('ul-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }